/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFormik} from "formik";
import {useDispatch, useSelector,} from "react-redux";
import {notification} from "@/store/modules/notification";
import {StoreUtil} from "@/util/store/StoreUtil";
import {BaseInput} from "../input/BaseInput";
import {RootState} from "@/store/modules";
import {entity} from "@/store/modules/entity.ts";
import {DeleteEntityRequest, DeleteEntityRequestInit} from "@/model/request/entity/DeleteEntityRequest.ts";
import {BaseModal} from "@/components/modal/BaseModal.tsx";
import {base} from "@/store/modules/base.ts";


export default function DeleteEntityModal() {
    const dispatch = useDispatch<any>();
    const EntityState = useSelector((state: RootState) => state.entity)
    const applicationState = useSelector((state: RootState) => state.application)
    const showErrorMessage = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "error",
                    title: "Error",
                    body: response.responseMessage,
                })
            )
        );
    };

    // const navigate = useNavigate()

    const showSuccessMessage = (response: any) => {
        StoreUtil.execute(() => {
            dispatch(entity.action.readByEntityApplicationId({entityApplicationId: applicationState?.selectedApplication?.applicationId}))
            dispatch(
                notification.mutation.openModal({
                    type: "success",
                    title: "Success",
                    body: response.responseMessage,
                })
            )
        })
    };
    const handleSubmit = async (value: DeleteEntityRequest) => {
        const request = {
            ...value,
            entityId: EntityState.selectedEntity?.entityId ? EntityState.selectedEntity?.entityId : 0,
        };
        await dispatch(
            entity.action.delete({
                data: request,
                onSuccess: (response: any) => {
                    showSuccessMessage(response)
                },
                onError: (response: any) => showErrorMessage(response),
            })
        )
        formik.resetForm();
    };

    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: DeleteEntityRequestInit,
    });
    return (

        <BaseModal title={"Delete Entity"} subtitle={`${EntityState.selectedEntity?.entityName}`}>
            <div className="workspace-content">
                <form onSubmit={formik.handleSubmit}>
                    <div className="flex btns">
                        <a className="button is-secondary w-button"
                           onClick={() => dispatch(base.mutation.resetModalOptions())}>Cancel</a>
                        <BaseInput
                            type="submit"
                            formik={formik}
                            name={"submit"}
                            value={"Yes, Delete"}
                            loading={EntityState.loading}
                            className={"button w-button"}
                        />
                    </div>
                </form>
            </div>
        </BaseModal>

    );
}



